import { SupplyItemStatus, SupplyShipmentCarrier } from '@caresend/types';
import { capitalize } from './string.js';
import { arrayToObj } from '../languageExtensions/array.js';
import 'lodash-unified';

const initSkuObject = (id, expiry, supplyID, supplyItems) => ({
  active: true,
  creationTimestamp: Date.now(),
  expiry,
  id,
  supplyID,
  supplyItems
});
const initBatchItemSupplyItems = (skuID, serials) => {
  const supplyItemsArray = serials.map(serial => ({
    id: `${skuID}-${serial}`,
    skuID,
    serial,
    status: SupplyItemStatus.CREATED
  }));
  return arrayToObj(supplyItemsArray, 'id');
};
/**
 * Formats the delivery methods for supply shipments according to
 * standard formatting of the delivery companies.
 *
 * ex:
 * fedEx -> FedEx
 * usps -> USPS
 */

const formatSupplyShipmentCarrier = deliveryMethod => {
  switch (deliveryMethod) {
    case SupplyShipmentCarrier.USPS:
    case SupplyShipmentCarrier.UPS:
      return deliveryMethod.toUpperCase();

    default:
      return capitalize(deliveryMethod);
  }
};

export { formatSupplyShipmentCarrier, initBatchItemSupplyItems, initSkuObject };
